export default (scopes) => {
	const normalizeAssignedScopes = [...scopes];
	return normalizeAssignedScopes;
};
